import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent, Grid } from '@material-ui/core';
import styles from 'styles/admin-detail.module.scss';
import {
  SAME_OR_NOT_TYPE_VALUES,
  DRIVER_TYPE_VALUES,
  DRIVER_LICENSE_COLOR,
  GENDER,
} from 'const';
import { convertToJapaneseCalendar } from 'utils/japaneseCalendarConverter';
import { getStylesBackgroundColor} from 'views/Detail/components';
import { getStylesLabelColorLine} from 'views/Detail/components';

const NenreisDetail = (props) => {
  const { nenrei, insuranceType } = props;

  var driverList = [];
  if (nenrei?.driverType) {
    for (var i in nenrei?.driverType.split(',')) {
      driverList.push(
        <p key={i}>{DRIVER_TYPE_VALUES[nenrei?.driverType.split(',')[i]]}</p>
      );
    }
  }

  return (
    <Card>
      <CardHeader
        title='運転者限定・年齢条件'
        className={getStylesBackgroundColor(insuranceType)}
      />
      <CardContent className={styles.cardContent}>
        <Grid container spacing={5}>
          <Grid item xs={4}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>変更後にお車を運転される方の情報</p>
              {driverList.length > 0 && (
                <div className={styles.text}>{driverList}</div>
              )}
              {driverList.length === 0 && (
                <p className={styles.text}>{'-'}</p>
              )}
            </div>
          </Grid>
          <Grid item xs={5}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>
                変更後の最若年運転者と記名被保険者（主にお車を運転される方）の関係
              </p>
              <p className={styles.text}>
                {nenrei?.relationWithYoungest
                  ? SAME_OR_NOT_TYPE_VALUES[nenrei.relationWithYoungest]
                  : '-'}
              </p>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={5}>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>変更後の最若年運転者の生年月日</p>
               <p className={styles.text}>{convertToJapaneseCalendar(nenrei?.birthdayOfYoungest) || '-'}</p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>変更後の最若年運転者の年齢</p>
              <p className={styles.text}>{nenrei?.ageOfYoungest || '-'}</p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>変更後の最若年運転者の性別</p>
              <p className={styles.text}>
                {nenrei?.genderOfYoungest
                  ? GENDER[nenrei.genderOfYoungest]
                  : '-'}
              </p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>変更後の最若年運転者の免許証の色</p>
              <p className={styles.text}>
                {nenrei?.driverLicenseColorOfYoungest
                  ? DRIVER_LICENSE_COLOR[nenrei.driverLicenseColorOfYoungest]
                  : '-'}
              </p>
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

NenreisDetail.propTypes = {
  className: PropTypes.string,
};

export default NenreisDetail;
